export const animationlabel = () => {
  let loginLabelGmail = document.querySelector(".loginLabelGmail");
  let loginInputGmail = document.querySelector(".loginInputGmail");
  let loginLabelPass = document.querySelector(".loginLabelPass");
  let loginInputPass = document.querySelector(".loginInputPass");
  
  
  let signinLabelName = document.querySelector('.signLabelName')
  let signinInputName = document.querySelector('.signInputName')
  let signinLabelGmail = document.querySelector('.signLabelGmail')
  let signinInputGmail = document.querySelector('.signInputGmail')
  let signinLabelPass = document.querySelector('.signLabelPass')
  let signinInputPass = document.querySelector('.signInputPass')

  // Handling the labels
  const loginGmailLabelDisappear = () => {
    loginLabelGmail.style.display = "none";
  }

  const loginGmailLabelAppear = () => {
    loginLabelGmail.style.display = "block";
  }

  const loginPasswordLabelDisappear = () => {
    loginLabelPass.style.display = 'none';
  }

  const loginPasswordLabelAppear = () => {
    loginLabelPass.style.display = 'block';
  }

  loginInputGmail.addEventListener("focus", loginGmailLabelDisappear)
  loginInputGmail.addEventListener("focusout", loginGmailLabelAppear)

  loginInputPass.addEventListener("focus", loginPasswordLabelDisappear)
  loginInputPass.addEventListener("focusout", loginPasswordLabelAppear)


  // For the form signup
  const signinGmailLabelDisappear = () => {
    signinLabelGmail.style.display = "none";
  }

  const signinGmailLabelAppear = () => {
    signinLabelGmail.style.display = "block";
  }

  const signinPasswordLabelDisappear = () => {
    signinLabelPass.style.display = 'none';
  }

  const signPasswordLabelAppear = () => {
    signinLabelPass.style.display = 'block';
  }

  const signinNameLabelDisappear = () => {
    signinLabelName.style.display = 'none';
  }

  const signinNameLabelAppear = () => {
    signinLabelName.style.display = 'block';
  }

  signinInputGmail.addEventListener("focus", signinGmailLabelDisappear)
  signinInputGmail.addEventListener("focusout", signinGmailLabelAppear)

  signinInputPass.addEventListener("focus", signinPasswordLabelDisappear)
  signinInputPass.addEventListener("focusout", signPasswordLabelAppear)

  signinInputName.addEventListener("focus", signinNameLabelDisappear)
  signinInputName.addEventListener("focusout", signinNameLabelAppear)
};
